import { render } from "./HeroiconsOutlineCurrencyBangladeshi.vue?vue&type=template&id=1a146b33"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCurrencyBangladeshi.vue"]])

export default __exports__